import { render } from "./RenderingAListOfData.vue?vue&type=template&id=c8524042"
import script from "./RenderingAListOfData.vue?vue&type=script&lang=js"
export * from "./RenderingAListOfData.vue?vue&type=script&lang=js"

import "./RenderingAListOfData.vue?vue&type=style&index=0&id=c8524042&lang=css"
script.render = render

export default script